module.exports = __webpack_public_path__ + "static/media/pasc_logo.6148ab86.png";